export default __webpack_public_path__ + "static/media/IconAutomation.3313cb2e.png";